import type { SupabaseClient } from '@supabase/supabase-js'

export type MailApiGet = <T>(path: string) => Promise<T>

/**
 * Builds the `apiGet` that mail's search/context-card provider factories
 * need. Mail's data lives behind the Omni-Email `/api` deploy (apps/next,
 * NOT in this monorepo) — so this returns null when VITE_API_BASE_URL is
 * unset, and callers skip mail's providers entirely.
 */
export function makeMailApiGet(client: SupabaseClient): MailApiGet | null {
  const base = import.meta.env.VITE_API_BASE_URL as string | undefined
  if (!base) return null
  return async <T>(path: string): Promise<T> => {
    const { data } = await client.auth.getSession()
    const token = data.session?.access_token
    const res = await fetch(base + path, {
      credentials: 'include',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    })
    if (!res.ok) {
      throw new Error(`Mail API ${res.status} for ${path}`)
    }
    return (await res.json()) as T
  }
}
